export default __webpack_public_path__ + "static/media/carret.1721fd25.svg";